export default __webpack_public_path__ + "static/media/BrainBreak cards29.d845ca3e.png";